import type { SVGProps } from 'react';

const Svg2022UadCommentAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20 10c-.55 0-1 .45-1 1v3c0 .55-.45 1-1 1s-1 .45-1 1v2.87l-4.08-3.4c-.36-.3-.81-.46-1.28-.46H6c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h7c.55 0 1-.45 1-1s-.45-1-1-1H6C4.35 3 3 4.35 3 6v8c0 1.65 1.35 3 3 3h5.64l4.08 3.4a1.99 1.99 0 0 0 2.13.28c.71-.33 1.15-1.03 1.15-1.81v-2.04c1.16-.41 2-1.52 2-2.83v-3c0-.55-.45-1-1-1"
    />
    <path
      fill="currentcolor"
      d="M17 8c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1m-9 3c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm15-8h-2V1c0-.55-.45-1-1-1s-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V5h2c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default Svg2022UadCommentAdd;
